module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/AmwayIcons.ttf?5v2gxx
// module id = 8RLl
// module chunks = 0